import EspecialistaService from '../../services/EspecialistaService'

const state = () => ({
    especialistas: [],
    loadingEspecialista: false,
    loadingMoreEspecialista: false,
    // { nome, uf, latitude, longitude } ou '' quando nenhuma busca foi feita
    cidadePesquisada: '',
    // nome digitado na busca por nome (clínica ou especialista) ou ''
    nomePesquisado: '',
    // 'especialista' | 'clinica' da última pesquisa
    tipoPesquisado: '',
    pages: 0,
    page: 1
})

const mutations = {
  SET_ESPECIALISTAS: (state, payload) => {
    state.especialistas = payload.especialistas;
    state.pages = payload.pages;
    state.page = payload.page;
  },
  SET_MORE_ESPECIALISTAS: (state, payload) => {
    state.especialistas = [...state.especialistas, ...payload.especialistas]
    state.pages = payload.pages;
    state.page = payload.page;
  },
  SET_LOADING_ESPECIALISTAS: (state, payload) => {
    state.loadingEspecialista = payload
  },
  SET_LOADING_MORE_ESPECIALISTAS: (state, payload) => {
    state.loadingMoreEspecialista = payload
  },
  CLEAR_BUSCA(state) {
    state.especialistas = []
    state.page = 1;
    state.pages = 0;
    state.cidadePesquisada = '';
    state.nomePesquisado = '';
    state.tipoPesquisado = '';
  },
  SET_CIDADE_PESQUISADA(state, city) {
    state.cidadePesquisada = city
  },
  SET_NOME_PESQUISADO(state, name) {
    state.nomePesquisado = name
  },
  SET_TIPO_PESQUISADO(state, tipo) {
    state.tipoPesquisado = tipo
  }
}

const actions = {
  // Ponto único de entrada de uma nova busca (cidade selecionada ou geolocalização)
  async pesquisar({ commit, dispatch }, { nome, uf, latitude, longitude, type }) {
    commit('CLEAR_BUSCA')
    commit('SET_CIDADE_PESQUISADA', { nome, uf, latitude, longitude })
    commit('SET_TIPO_PESQUISADO', type)
    await dispatch('carregarEspecialista', { lat: latitude, lng: longitude, type })
  },
  // Busca pelo nome do especialista ou da clínica (sem localização)
  async pesquisarPorNome({ commit, dispatch }, { name, type }) {
    commit('CLEAR_BUSCA')
    commit('SET_NOME_PESQUISADO', name)
    commit('SET_TIPO_PESQUISADO', type)
    await dispatch('carregarEspecialista', { name, type })
  },
  limparPesquisa({ commit }) {
    commit('CLEAR_BUSCA')
  },
  async carregarEspecialista({ commit }, {lat, lng, name, page = 1, type}) {
    try {
      commit('SET_LOADING_ESPECIALISTAS', true);
      const response = await EspecialistaService.getBuscarEspecialistas({ lat, lng, name, page, type });
      commit('SET_ESPECIALISTAS', response.data)
      commit('SET_LOADING_ESPECIALISTAS', false);

    } catch (error) {
      commit('SET_LOADING_ESPECIALISTAS', false);
      console.error('Erro ao buscar especialistas:', error);
    }
  },
  async carregarMoreEspecialista({ commit }, {lat, lng, name, page, type}) {
    try {
      commit('SET_LOADING_MORE_ESPECIALISTAS', true);
      const response = await EspecialistaService.getBuscarEspecialistas({ lat, lng, name, page, type });
      setTimeout(() => {
        commit('SET_MORE_ESPECIALISTAS', response.data)
        commit('SET_LOADING_MORE_ESPECIALISTAS', false);
      }, 1000);

    } catch (error) {
      commit('SET_LOADING_MORE_ESPECIALISTAS', false);
      console.error('Erro ao buscar especialistas:', error);
    }
  }
}

const getters = {
  getCidadePesquisada: state => state.cidadePesquisada,
  getNomePesquisado: state => state.nomePesquisado,
  getTipoPesquisado: state => state.tipoPesquisado,
  getEspecialistas: state => state.especialistas,
  getLoadingEspecialista: state => state.loadingEspecialista,
  getLoadingMoreEspecialista: state => state.loadingMoreEspecialista,
  getTotalPaginasEspecialistas: state => state.pages,
  getPage: state => state.page
}

export default {
  state,
  getters,
  mutations,
  actions
};
